export default __webpack_public_path__ + "static/invest_gda-6181fed98e30c5d9ba72073418eea951.svg";